import { features } from 'reactApp/mail-features';

/** Отключение аналитики по тамбам */
export const disableThumbLogs = features.has('disable-thumb-logs');

export const maxFileNameLength: number = features.getAsInt('thumb-max-name-length', 96);
